import NavHeader from "./NavHeader";
import React from "react";
import Cart from "@/features/cart/Cart";
import { shopifyCartApi } from "@/services/shopifyCart";
import { useCustomer } from "../CustomerContext";
import { NavData } from "@/features/nav/NavItem";

const NavState = ({
  navigationData,
}: {
  navigationData: {
    leftDesktopNavData: NavData[];
    rightDesktopNavData: NavData[];
    mobileNavData: NavData[];
  };
}) => {
  const customer = useCustomer();
  const shopifyCart = shopifyCartApi.useFetch();
  const cartItems = shopifyCart.data?.items ?? [];
  const totalProducts = cartItems.reduce(
    (aggregator, value) => aggregator + value.quantity,
    0
  );

  const accountLink = customer?.hasSubscriptions
    ? "/tools/recurring/login"
    : "/account";
  return (
    <>
      <Cart />
      <NavHeader
        cartCount={totalProducts.toString(10)}
        customerName={customer ? customer.firstName : undefined}
        accountLink={accountLink}
        navigationData={navigationData}
      />
    </>
  );
};

export default NavState;
